export default {
    footer: {
        height: '5vh',
        display: 'flex',
        justifyContent: 'flex-end',
        alignContent: 'center',
        fontWeight: 'bold'
    },
    emoji:{
        margin: '0 10px'    }
}